import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { addReadingTime, emptyReadingProfile, localReadingDay, type BookReadingProfile } from '../services/explore/bookReading';

interface ReadingState {
  profiles: Record<string, BookReadingProfile>;
  visit: (childId: string, bookId: string, at?: number) => void;
  addTime: (childId: string, bookId: string, start: number, end: number) => void;
  setProgress: (childId: string, bookId: string, progress: number) => void;
}
export const useBookReadingStore = create<ReadingState>()(persist((set) => ({
  profiles: {},
  visit: (childId,bookId,at=Date.now()) => set(state => {
    const profile = state.profiles[childId] ?? emptyReadingProfile, day = localReadingDay(new Date(at));
    return { profiles: { ...state.profiles, [childId]: { days: { ...profile.days, [day]: { ...profile.days[day], [bookId]: profile.days[day]?.[bookId] ?? 0 } }, books: { ...profile.books, [bookId]: { progress: profile.books[bookId]?.progress ?? 0, lastOpenedAt: new Date(at).toISOString() } } } } };
  }),
  addTime: (childId,bookId,start,end) => set(state => {
    const profile = state.profiles[childId] ?? emptyReadingProfile;
    return { profiles: { ...state.profiles, [childId]: { ...profile, days: addReadingTime(profile.days,bookId,start,end) } } };
  }),
  setProgress: (childId,bookId,progress) => set(state => {
    const profile = state.profiles[childId] ?? emptyReadingProfile;
    return { profiles: { ...state.profiles, [childId]: { ...profile, books: { ...profile.books, [bookId]: { lastOpenedAt: profile.books[bookId]?.lastOpenedAt ?? new Date().toISOString(), progress: Math.max(profile.books[bookId]?.progress ?? 0,Math.min(1,Math.max(0,progress))) } } } } };
  })
}), { name: 'lusky:book-reading:v1', storage: createJSONStorage(()=>localStorage) }));
